// @flow
import typeof History from 'react-router-dom';
import { PROCEED, ACTION_TYPE, DEFAULT_MESSAGE } from 'esm-web-pro/redux/confirmations/constants';
import {
    CLOSE_TOPMOST, CLOSE_BY_KEY, CLOSE_ALL, MOUNT_POINT, SIDE_PANEL_CONFIRMATION_CATEGORY,
    OPEN, SET_SENSITIVITY, CLOSE_NAMESPACE,
} from './constants';
import { askForConfirmation, closeConfirmation } from '../confirmations/actions';
import { type SidePanel } from './reducer';
import type { State } from './reducer';

const checkSensitivePanel = (panel, history) => (panel && panel.sensitive
    && (!panel.url || panel.url === history.location.pathname));

const dispatchConfirmation = (panel: SidePanel, store, action) => (
    store.dispatch(askForConfirmation(
        SIDE_PANEL_CONFIRMATION_CATEGORY,
        ACTION_TYPE,
        action,
        { message: panel.confirmMessage },
    )));

let unblock;

const middleware = (history: History) => (store) => (next) => (action) => {
    if ((action.type === CLOSE_ALL || action.type === CLOSE_TOPMOST) && !action.payload.skipSensitivity) {
        const panels: State = store.getState()[MOUNT_POINT];
        let dispatched;
        // $FlowFixMe
        (Object.values(panels): Array<SidePanel>).every((panel: SidePanel) => {
            if (checkSensitivePanel(panel, history)) {
                dispatched = dispatchConfirmation(panel, store, action);
                return false;
            }
            return true;
        });

        if (dispatched) return dispatched;
    }

    if (action.type === CLOSE_BY_KEY && !action.payload.skipSensitivity) {
        const panel: SidePanel = store.getState()[MOUNT_POINT][action.payload.key];

        if (checkSensitivePanel(panel, history)) {
            return dispatchConfirmation(panel, store, action);
        }
    }

    if ((action.type.indexOf(CLOSE_NAMESPACE) === 0 || action.type === SET_SENSITIVITY)
        && unblock && (
        (action.payload && action.payload.skipSensitivity)
            || (action.type === SET_SENSITIVITY && !action.payload.sensitive)
    )) {
        unblock();
        unblock = null;
    }

    // We need to unblock first, as the router logs a warning that there can be only one active block
    if ((action.type === OPEN || action.type === SET_SENSITIVITY) && action.payload.sensitive) {
        if (unblock) {
            unblock();
        }
        unblock = history.block(() => (
            typeof action.payload.sensitive === 'boolean' ? DEFAULT_MESSAGE : action.payload.sensitive.message
        ));
    }
    if (action.type === PROCEED) {
        if (unblock) {
            unblock();
            unblock = null;
        }

        store.dispatch(closeConfirmation(SIDE_PANEL_CONFIRMATION_CATEGORY));
        const interceptedAction = action.payload.action.data;
        const actionType = action.payload.action.type;

        if (actionType === ACTION_TYPE) {
            interceptedAction.payload.skipSensitivity = true;
            return next(interceptedAction);
        }
    }
    return next(action);
};

export default middleware;
